import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { View } from "@/views/component/dayRecharge/style";
import Button from "@/views/component/public/button";
import { EButton, EModal } from "@/interface/enum";
import { useCookieState, useLockFn, useMemoizedFn, useRequest } from "ahooks";
import { ConfDoData, ConfDoEntrys, ConfDoEntrysTasks, Res } from "@/interface/request.interface";
import { $ajax, conf, joinAndFinish } from "@/utils/request";
import { Award, IRecentPlayGs, Modal } from "@/views/component/modal";
import { catchModal, filterMonthGame, getDayEndTime, statClick } from "@/utils/util";
import { useMobx } from "@/utils/hooks";
import { observer } from "mobx-react-lite";


function transformTask(gameList: ConfDoEntrys[]): ConfDoEntrysTasks[][] {
  const allList = [];
  for (let i = 0; i < gameList.length; i++) {
    const gameItem = [];
    let gameEntrys = gameList[i].tasks;

    while (gameEntrys.length) {
      gameItem.push(gameEntrys.splice(0, 4));
    }


    const list = []
    for (let j = 0; j < gameItem[0].length; j++) {
      const row = [];
      for (let item of gameItem) {
        row.push(item[j]);
      }
      list.push(row);
    }

    allList.push(list);
  }
  return allList[0];
}

function Index() {
  const store = useMobx('store');
  const operate = useMobx('operate');
  const [task, triggerTask] = useState<ConfDoEntrysTasks[][]>([]);
  const [checkStr, triggerCheck] = useCookieState('checkRechaegeAward', {
    defaultValue: '[]',
    expires: new Date(getDayEndTime().getTime() + 60 * 1000 * 60 * 8)
  });
  const check = useRef<number[]>(JSON.parse(checkStr || '[]'));

  const taskRowIdx = useRef(-1);
  const serverListVerify = useRef<IRecentPlayGs[]>([]);

  // 获取奖励配置
  const { runAsync: confAward } = useRequest<ConfDoData, any>(conf(CONFIG.code.act_dayRechargeTask), {
    manual: true
  });

  const { runAsync: runAsync_01, loading: loading_recentGame } = useRequest(() => $ajax<IRecentPlayGs[]>('//task3game.yy.com/act/recentPlayGs.do', {
    data: {
      act: CONFIG.code.YYVIP2022_free_01, // 活动代号
      innerRef: store.urlParams.HD[0], // 埋点字符
      lastDayNum: 30, //	最近多少天参与游戏（天）
    },
    dataType: 'jsonp'
  }), {
    manual: true,
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    }
  });
  const initRecentGame = useMemoizedFn(async ()=>{
    const res1 = await runAsync_01();
    const list = filterMonthGame(res1);

    if (list.length === 0) {
      return catchModal(EModal['提示'], {
        message: '充值金额不足',
        btnType: EButton['弹窗-前往充值'],
        confirmFn: (props: any) => {
          setTimeout(handleRechargeModal, 500);
          props.clearAll()
        }
      });
    }
    serverListVerify.current = list;
    await eachJoinAwardStatus();
  })

  // 领取奖品
  const { runAsync: getAward, loading: loading_getAward } = useRequest(joinAndFinish, {
    manual: true,
    onSuccess: (data, params) => {
      serverListVerify.current = [];
      taskRowIdx.current = -1;

      const { taskId } = params[0];
      // 获取奖励的行列索引
      const [row, col] = task
        .map((row, index) => {
          return row.map((award, idx) => {
            if (award.id === taskId) {
              return [index, idx];
            }
          }).filter(Boolean)
        })
        .filter((item) => item.length)
        .flat(Infinity) as [number, number];
      const award = CONFIG.everyDayRecharge.tasks[row].award[col];

      $refPopup.current.open(<Modal modalType={EModal['恭喜获得']}>
        <Award name={award.name} awardImg={award.popupAward}/>
      </Modal>);


      if (store.noParticipate) {
        store.updateParticipate();
        statClick();
      }
      statClick(`zrw${row + 1}`, `每日充值奖励${row + 1}`);

      init();

      setTimeout(() => {
        operate.initMonthRecharge();
      }, 1500);
    },
    onError: async (error) => {
      if (serverListVerify.current.length === 0) {
        const res: Res = JSON.parse(error.message);
        if (res.status === 411) {
          return catchModal(EModal['提示'], {
            message: res.message,
            btnType: EButton['弹窗-前往充值'],
            confirmFn: (props: any) => {
              setTimeout(handleRechargeModal, 500);
              props.clearAll()
            }
          });
        }
        return catchModal(EModal['提示'], { message: res.message });
      }

      await eachJoinAwardStatus();
    }
  });

  // 是否为VIP用户
  const { runAsync: isVipUser } = useRequest(() => $ajax<boolean>(`//gxhd.game.yy.com/yyvip/isvip.do`), {
    manual: true
  });

  const init = async () => {
    const task = await confAward();
    const list = transformTask(task.entrys);
    triggerTask(list);
    operate.setDayRechargeTask(list);
  }

  useEffect(() => {
    init();
  }, []);

  const eachJoinAwardStatus = async () => {
    const item = serverListVerify.current.splice(0, 1)[0];
    const idx = taskRowIdx.current;
    await getAward({
      actCode: CONFIG.code.act_dayRechargeTask,
      taskId: task[idx][check.current[idx]].id,
      serverId: item.serverId,
      gameId: item.gameId
    })
  }

  const handlChecked = useMemoizedFn((row: number, idx: number) => {
    check.current[row] = idx;
    triggerCheck(JSON.stringify(check.current));
  });

  const handleGetAward = useLockFn(async (taskIdx: number) => {
    const idx = check.current[taskIdx];
    if ([null, undefined].includes(idx as any)) {
      return $refPopup.current.open(<Modal modalType={EModal['提示']} message={'请选择一个奖品'}/>);
    }

    // 靓号贵族需要验证是否为VIP账户
    if (CONFIG.everyDayRecharge.tasks[taskIdx].award[idx].verifyVIP) {
      const isVip = await isVipUser();
      if (isVip === false) {
        return $refPopup.current.open(<Modal modalType={EModal['提示']} message={'该奖品需要YY会员激活，请领取其他奖品'}/>);
      }
    }

    taskRowIdx.current = taskIdx;
    await initRecentGame();
  })

  const handleRechargeModal = useCallback(() => {
    $refPopup.current.open(<Modal modalType={EModal['充值区服']}/>);
  }, [])

  return <View>
    {CONFIG.everyDayRecharge.tasks.map((item: any, index: number) => {
      const on_off = task[index] && task[index].some((val) => val.taskStatus === 100);
      const eventStatus = !on_off && !loading_recentGame && !loading_getAward;
      const rowNoChecked = [null, undefined].includes(check.current[index] as any);

      return <div className='taskItem' key={index}>
        <p>{item.name}</p>
        <ul>
          {item.award.map((val: any, idx: number) => {
            const style = check.current[index] === idx ? 'active' : (rowNoChecked ? '' : 'normal');
            return <li key={idx}
                       className={style}
                       onClick={() => {eventStatus && handlChecked(index, idx)}}
            >
              <img src={val.awardImg} alt=""/>
              <p>{val.name}</p>
            </li>
          })}
        </ul>
        <Button onClick={() => {eventStatus && handleGetAward(index)}} type={EButton['每日充值-领取']} status={on_off ? 100 : 0}/>
      </div>
    })}
    <p className='tip'>
      <span>{CONFIG.everyDayRecharge.bottomLeft}</span>
      <span onClick={() => handleRechargeModal()}>{CONFIG.everyDayRecharge.bottomRight[0]}</span>
    </p>
  </View>
}

export default observer(Index);
